import React from 'react';
import { useSelector } from 'react-redux';

import { Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  loading: true,
  type: '',
  moda_type: '',
  shipping_method: {
    value: 'inhouse',
  },
  vendor: null,
  vehicleType: null,
  serviceType: null,
};

const modaOptions = [
  {
    value: 'land_freight',
    label: 'Darat',
  },
  {
    value: 'sea_freight',
    label: 'Laut',
  },
  {
    value: 'air_freight',
    label: 'Udara',
  },
];

export const Manifest = ({ onChange, data, form_general }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [
    { loading, moda_type, shipping_method, vendor, vehicleType, serviceType },
    setState,
  ] = React.useState(initialState);

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
    }, 2000);
  }, [loading]);

  React.useEffect(() => {
    const state = {
      moda_type,
      shipping_method,
      vendor,
      vehicleType,
      serviceType,
    };

    onChange(state);
  }, [moda_type, shipping_method, vendor, vehicleType, serviceType]);

  React.useEffect(() => {
    if (!data) return;

    if (data?.auto_manifest) {
      const mt =
        data?.moda_type === 'land_freight'
          ? modaOptions[0]
          : data?.moda_type === 'sea_freight'
          ? modaOptions[1]
          : data?.moda_type === 'air_freight'
          ? modaOptions[2]
          : null;

      setState((prevState) => ({
        ...prevState,
        loading: true,
        moda_type: mt,
        shipping_method: {
          value: data?.shipping_method,
        },
        vendor: data?.vendor,
        vehicleType: data?.vehicle_type,
        serviceType: data?.vendor_service_type,
      }));
    } else {
      setState({ ...initialState });
    }
  }, [data]);

  return (
    <div className="" id="form-manifest">
      <div className="bg-white row mb-2 border-bottom px-3 py-3">
        <div className="col-sm-12">
          <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
            Manifest
          </div>
        </div>
      </div>

      <div className="mb-3 px-4 pb-2">
        <div className="row border bg-white">
          <div className="col-md-6 p-3 pt-3">
            {loading ? (
              <SkeletonsForm count={2} />
            ) : (
              <>
                {shipping_method?.value === 'inhouse' && (
                  <div className="mb-3">
                    <label className="form-label fs-8 required">
                      Pilih Moda
                    </label>
                    <Select
                      isClearable
                      classNamePrefix={
                        StateForm?.errors?.['manifest.moda_type']
                          ? 'is-invalid'
                          : 'select'
                      }
                      placeholder=""
                      value={moda_type}
                      options={modaOptions}
                      onChange={(e) => {
                        setState((prevState) => ({
                          ...prevState,
                          moda_type: e,
                        }));
                      }}
                    />

                    {StateForm?.errors?.['manifest.moda_type'] ? (
                      <div className="invalid-feedback d-block ">
                        {StateForm?.errors?.['manifest.moda_type']}
                      </div>
                    ) : null}
                  </div>
                )}
                {moda_type?.value === 'land_freight' && (
                  <div className="mb-3">
                    <Select.Remote
                      required
                      label="Pilih Jenis Kendaraan"
                      placeholder=""
                      url="/tms/vehicle/type"
                      value={vehicleType}
                      initialValue={vehicleType?.id}
                      keys={vehicleType?.id}
                      row={(d) => {
                        return {
                          value: d.id,
                          label: d?.karoseri_type
                            ? `${d?.name} - ${d?.karoseri_type}`
                            : `${d?.name}`,
                        };
                      }}
                      onSelected={(c) => {
                        setState((prevState) => ({
                          ...prevState,
                          vehicleType: c,
                        }));
                      }}
                      errors={StateForm?.errors?.['manifest.vehicle_type_id']}
                    />
                  </div>
                )}
              </>
            )}
          </div>
          <div className="col-md-6 p-3 pt-3">
            {loading ? (
              <SkeletonsForm count={2} />
            ) : (
              <>
                <div className="mb-3">
                  <Select.Remote
                    required={shipping_method?.value === 'external'}
                    label="Pilih Vendor"
                    placeholder=""
                    url="/partner"
                    value={vendor}
                    initialValue={vendor?.id}
                    keys={vendor?.id}
                    params={{"type": "vendor"}}
                    row={(d) => {
                      return {
                        value: d.id,
                        label: d.name,
                      };
                    }}
                    onSelected={(c) => {
                      setState((prevState) => ({
                        ...prevState,
                        vendor: c,
                      }));
                    }}
                    errors={StateForm?.errors?.['manifest.vendor_id']}
                  />
                </div>
                {vendor && vendor?.partner_id !== '' && (
                  <div className="mb-3">
                    <Select.Remote
                      label="Pilih Tipe Layanan"
                      placeholder=""
                      url="/tms/service/type"
                      value={serviceType}
                      initialValue={serviceType?.id}
                      params={{
                        service_id: '61cc19d9f42b986ab50c659b',
                        partner_id: vendor?.partner_id,
                      }}
                      row={(d) => {
                        return {
                          value: d.id,
                          label: d.name,
                        };
                      }}
                      onSelected={(c) => {
                        setState((prevState) => ({
                          ...prevState,
                          serviceType: c,
                        }));
                      }}
                      keys={vendor?.id}
                      hint={
                        serviceType?.pricing_schema === 'weight_based'
                          ? `min. weight : ${serviceType?.min_weight} Kg`
                          : null
                      }
                      errors={StateForm?.errors?.['manifest.service_type_id']}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
